/* eslint-disable react-hooks/exhaustive-deps */
import { Dialog } from "@progress/kendo-react-dialogs";
import "../../styles/campaigns/previewLeads.css";
import "../../styles/shared/loadingPage.css";
import { useEffect, useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { previewLeadsListColumn } from "./gridColumns";
import { Pager } from "@progress/kendo-react-data-tools";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { useNavigate } from "react-router-dom";
import fetchClient from "../../api/fetch";
import { Loader } from "@progress/kendo-react-indicators";
import { getTranslation } from "../../common/translation";
import { useTranslation } from "react-i18next";

const PreviewLeadsModal = ({
  setShowPreviewLeads,
  setShowCampaignNameExistError,
  setSuccessModalValues,
  leadsReferenceKey,
  getLeadsList,
  leadsList,
  leadsListPage,
  marketSettings,
  uncheckedIds,
  payload,
  mode,
  id,
}) => {
  const { t } = useTranslation();
  const Navigate = useNavigate();
  const columns = previewLeadsListColumn;

  const [page, setPage] = useState({
    skip: 0,
    take: 10,
  });
  const [pageSizeValue, setPageSizeValue] = useState();
  const [sort, setSort] = useState([]);
  const [filter, setFilter] = useState(undefined);
  const [params, setParams] = useState({
    sort: "",
    filter: [],
  });
  const [leadsCount, setLeadsCount] = useState(undefined);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getLeadsList(queryBuilder());
  }, [page, params]);

  const queryBuilder = () => {
    const refKey = `referenceKey=${leadsReferenceKey}`;
    return `?${refKey}${params.sort}&page=${JSON.stringify(page)}&filters=[${
      params.filter
    }]`;
  };

  const pageChange = (e) => {
    const targetEvent = e.targetEvent;
    const take = e.take;
    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...e.page,
      skip: e.skip,
      take,
    });
  };

  const handleSort = (e) => {
    let sortVal = e.sort;
    setSort(sortVal);
    if (sortVal.length > 0) {
      sortVal = sortVal.map((s) => ({
        dir: s.dir,
        field: s.field.charAt(0).toUpperCase() + s.field.substr(1),
      }));
      let obj = { ...sortVal[0] };
      obj["direction"] = obj["dir"];
      delete obj["dir"];
      obj = JSON.stringify(obj);
      setParams({ ...params, sort: `&sort=${obj}` });
    } else {
      setParams({ ...params, sort: "" });
    }
  };

  const handleFilterChange = (e) => {
    setFilter(e.dataState.filter);
    if (e.dataState.filter !== undefined) {
      setParams({
        ...params,
        filter: e.dataState.filter.filters.map((item) => {
          let obj = { ...item };
          obj["condition"] = obj["operator"];
          delete obj["operator"];
          obj = JSON.stringify(obj);
          return obj;
        }),
      });
      setPage({
        ...page,
        skip: 0,
      });
    } else {
      setParams({ ...params, filter: "" });
    }
  };

  const handleChange = (e) => {
    setLeadsCount(e.value);
  };

  const handleSave = (event) => {
    setIsLoading(true);
    const ivids = event === "save" ? selectedLeads : [];

    const data = {
      ...payload,
      ivIds: ivids,
      saveUpTo: event === "saveUpTo" ? leadsCount : null,
      referenceKey: leadsReferenceKey,
    };

    let isSelectedReplacementId =
      payload.campaignReplacementVehicles.length > 0;
    let isSelectedIvId = payload.campaignExistingVehicles.length > 0;
    let selectedParams = `&isSelectedReplacementId=${isSelectedReplacementId}&isSelectedIvId=${isSelectedIvId}`;
    if (uncheckedIds.replacementVS.length > 0) {
      selectedParams += `&replacementVehicleId=${uncheckedIds.replacementVS.toString()}`;
    }
    if (uncheckedIds.existingVS.length > 0) {
      selectedParams += `&unselectedIvId=${uncheckedIds.existingVS.toString()}`;
    }

    if (mode === "create") {
      fetchClient()
        .post(
          `v1/campaigns/leads?${params.sort}&filters=[${params.filter}]` +
            selectedParams,
          data
        )
        .then(() => {
          setIsLoading(false);
          setShowPreviewLeads(false);
          setSuccessModalValues({
            message: "Campaign saved successfully",
            isVisible: true,
            closeCallBack: handleCloseModal,
          });
        })
        .catch(() => {
          setShowPreviewLeads(false);
          setShowCampaignNameExistError(true);
        });
    } else {
      fetchClient()
        .put(
          `v1/campaigns/${id}/leads?${params.sort}&filters=[${params.filter}]` +
            selectedParams,
          data
        )
        .then(() => {
          setIsLoading(false);
          setShowPreviewLeads(false);
          setSuccessModalValues({
            message: "Campaign saved successfully",
            isVisible: true,
            closeCallBack: handleCloseModal,
          });
        })
        .catch(() => {
          setShowPreviewLeads(false);
          setShowCampaignNameExistError(true);
        });
    }
  };

  const handleCloseModal = () => {
    Navigate("/campaigns");
  };

  const handleSelectAll = () => {
    if (!selectedLeads.length) {
      setSelectedLeads([""]);
    } else {
      setSelectedLeads([]);
    }
  };

  const handleSelect = (dataItem) => {
    const { ivId } = dataItem;
    if (selectedLeads.length && selectedLeads.includes(ivId)) {
      setSelectedLeads(selectedLeads.filter((lead) => lead !== ivId));
    } else {
      setSelectedLeads([...selectedLeads, ivId]);
    }
  };

  const customPager = (props) => {
    return (
      <div className="custom-pager">
        <Pager
          skip={props.skip}
          take={props.take}
          type="numeric"
          total={props.total}
          buttonCount={props.buttonCount}
          previousNext={true}
          pageSizes={props.pageSizes}
          pageSizeValue={props.pageSizeValue}
          onPageChange={pageChange}
        />
      </div>
    );
  };

  const actionsCell = ({ dataItem }) => {
    return (
      <td className="text-center">
        <Checkbox
          value={!selectedLeads.length || selectedLeads.includes(dataItem.ivId)}
          onChange={() => handleSelect(dataItem)}
        />
      </td>
    );
  };

  const equityCell = ({ dataItem }) => {
    const equityValue = dataItem.equityFormatted;
    const isNegative = equityValue?.toString()?.includes("-");
    return (
      <td
        colSpan={1}
        role="gridCell"
        className={`k-table-td ${isNegative ? "negative-equity" : "equity"}`}
      >
        {isNegative
          ? `(${currencyFormatter(equityValue)})`
          : `${currencyFormatter(equityValue)}`}
      </td>
    );
  };

  const currencyCell = (props) => {
    const { dataItem, field } = props;
    const value = dataItem[field];

    return (
      <td colSpan={1} role="gridCell" className="k-table-td">
        {`${currencyFormatter(value)}`}
      </td>
    );
  };

  const currencyFormatter = (value) => {
    let val = value?.toString();
    const isNegative = val?.includes("-");
    const currencySymbol = marketSettings.currencySymbol;

    if (val && isNegative) {
      const splitValue = val.split("-");
      val = `-${currencySymbol}${Number(splitValue[1])}`;
      return val;
    } else {
      return val ? `${currencySymbol}${Number(val)}` : null;
    }
  };

  const actionsHeaderCell = ({ dataItem }) => {
    return (
      <span className="k-cell-inner">
        <span className="k-link">
          <span>
            <Checkbox
              value={!selectedLeads.length}
              onChange={handleSelectAll}
            />
          </span>
          <span className="k-column-title select-all">
            {getTranslation("Select all", t)}
          </span>
        </span>
      </span>
    );
  };

  return (
    <Dialog
      className="preview-leads"
      onClose={() => setShowPreviewLeads(false)}
    >
      {isLoading ? (
        <div className="loading grid-light-background">
          <Loader type="converging-spinner" />
        </div>
      ) : null}

      <div className="d-flex flex-column gap-3 p-2">
        <h1 className="h1 mb-3">{getTranslation("Preview Leads", t)}</h1>
        <div className="modal-cont">
          <div className="grid-cont">
            <Grid
              className="grid-view"
              data={leadsList}
              skip={page.skip}
              take={page.take}
              total={leadsListPage.totalRecords}
              filterable={true}
              filter={filter}
              sortable={true}
              sort={sort}
              onSortChange={handleSort}
              onDataStateChange={handleFilterChange}
              pager={customPager}
              pageable={{
                buttonCount:
                  leadsListPage.totalPages > 10 ? 10 : leadsListPage.totalPages,
                pageSizes: [5, 10, 15],
                pageSizeValue,
              }}
            >
              {columns.map((column, idx) => {
                if (idx === 0) {
                  return (
                    <Column
                      key={idx}
                      width={column.width}
                      cell={actionsCell}
                      headerCell={actionsHeaderCell}
                      filterable={false}
                      title={getTranslation(column.title, t)}
                    />
                  );
                } else if (
                  getTranslation(column.title, t) ===
                  getTranslation("Equity", t)
                ) {
                  return (
                    <Column
                      key={idx}
                      field={column.column}
                      width={column.width}
                      cell={equityCell}
                      title={getTranslation(column.title, t)}
                      filterable={true}
                    />
                  );
                } else if (column.title === "Source") {
                  return (
                    <Column
                      key={idx}
                      field={column.column}
                      width={column.width}
                      title={getTranslation(column.title, t)}
                      filterable={false}
                    />
                  );
                } else if (
                  [
                    getTranslation("Cost to change", t),
                    getTranslation("New Payment", t),
                    getTranslation("Payment", t),
                    getTranslation("Payment Difference", t),
                  ].includes(getTranslation(column.title, t))
                ) {
                  return (
                    <Column
                      key={idx}
                      field={column.column}
                      width={column.width}
                      cell={currencyCell}
                      title={getTranslation(column.title, t)}
                      filterable={true}
                    />
                  );
                } else {
                  return column.isShown ? (
                    <Column
                      key={idx}
                      field={column.column}
                      width={column.width}
                      title={getTranslation(column.title, t)}
                      sortable={
                        column.sortable ||
                        getTranslation(column.title, t) !==
                          getTranslation("Source", t)
                      }
                      filterable={true}
                    />
                  ) : null;
                }
              })}
            </Grid>
          </div>
          <div className="buttons d-flex justify-content-start gap-2">
            <button
              className="d-flex justify-content-center align-items-center gap-2 secondary-btn cancel-btn"
              onClick={() => setShowPreviewLeads(false)}
            >
              <p className="m-0">{getTranslation("Cancel", t)}</p>
            </button>
            <button
              className="d-flex justify-content-center align-items-center gap-2 ms-5 primary-btn save-campaign-btn"
              onClick={() => handleSave("save")}
            >
              <p className="m-0">{getTranslation("Save campaign", t)}</p>
            </button>
            <button
              className="d-flex justify-content-center align-items-center gap-2 ms-5 primary-btn save-up-to-btn"
              onClick={() => handleSave("saveUpTo")}
              disabled={!leadsCount || leadsCount === 0}
            >
              <p className="m-0">{getTranslation("Save up to", t)}</p>
            </button>
            <Input
              className="k-input-flat leads-input ms-2"
              name="leadsCount"
              value={leadsCount}
              type="number"
              min={1}
              max={leadsListPage.totalRecords}
              onChange={handleChange}
            />
            <label className="d-flex align-items-end">
              {getTranslation("Leads", t)}
            </label>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PreviewLeadsModal;
